"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shareViewOptions = exports.menuListItems = exports.isStepper = exports.isFormula = exports.isContribution = exports.initialComplexFormula = exports.ACTIVE_TYPES = void 0;
var R = _interopRequireWildcard(require("ramda"));
var _utils = require("@trs/utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ACTIVE_TYPES = exports.ACTIVE_TYPES = {
  fixed: 'FIXED',
  percentage: 'PERCENTAGE'
};
var shareViewOptions = exports.shareViewOptions = function shareViewOptions(labels) {
  return [{
    name: 'share-block-view',
    value: ACTIVE_TYPES.fixed,
    id: 'share-option-fixed',
    naked: true,
    iconChecked: 'ion-android-radio-button-on',
    iconUnchecked: 'ion-android-radio-button-off',
    label: labels.FORMULA_SHARE_VIEW_FIXED
  }, {
    name: 'share-block-view',
    value: ACTIVE_TYPES.percentage,
    id: 'share-option-percentage',
    iconChecked: 'ion-android-radio-button-on',
    iconUnchecked: 'ion-android-radio-button-off',
    naked: true,
    label: labels.FORMULA_SHARE_VIEW_PERCENTAGE
  }];
};
var menuListItems = exports.menuListItems = function menuListItems(_ref) {
  var labels = _ref.labels,
    actions = _ref.actions,
    ruleIndex = _ref.ruleIndex,
    setHasChanges = _ref.setHasChanges;
  return [{
    name: labels.BUTTON_DELETE,
    icon: 'ion-trash-b',
    onClick: function onClick() {
      actions.deleteRuleFormulas(ruleIndex);
      setHasChanges(true);
    }
  }];
};
var isFormula = exports.isFormula = function isFormula(rule) {
  return !(0, _utils.isBlank)(R.prop('formula', rule));
};
var isStepper = exports.isStepper = function isStepper(_ref2) {
  var stepper = _ref2.stepper;
  return !(0, _utils.isBlank)(R.path([ACTIVE_TYPES.fixed, 'steps'], stepper)) || !(0, _utils.isBlank)(R.path([ACTIVE_TYPES.percentage, 'steps'], stepper));
};
var isContribution = exports.isContribution = function isContribution(rule) {
  return !(0, _utils.isBlank)(R.path(['complex', ACTIVE_TYPES.fixed, 'contribution'], rule)) || !(0, _utils.isBlank)(R.path(['complex', ACTIVE_TYPES.percentage, 'contribution'], rule));
};
var initialComplexFormula = exports.initialComplexFormula = function initialComplexFormula(_ref3) {
  var formula = _ref3.formula,
    rule = _ref3.rule;
  return _objectSpread(_objectSpread({}, rule.complex), {}, _defineProperty(_defineProperty({}, ACTIVE_TYPES.fixed, _objectSpread(_objectSpread({}, R.path(['complex', ACTIVE_TYPES.fixed], rule)), {}, {
    contribution: formula
  })), ACTIVE_TYPES.percentage, _objectSpread(_objectSpread({}, R.path(['complex', ACTIVE_TYPES.percentage], rule)), {}, {
    contribution: formula,
    additionalFormulaItems: formula
  })));
};